module.exports = __webpack_public_path__ + "static/media/navMenuBG.93636215.jpg";